export default __webpack_public_path__ + "static/media/1.1c8b3995.png";